import { KuxErrorType, KuxFilteredCategoriesDTO } from '@kaltura-ott/tvpil';

import { errorHandling } from '../../../../../utils/error-handling';
import { getCollectionData } from '../../../../../utils/getCollectionData';
import { CardPlaceholder, EntitiesType } from '../../../../entities';

import { CollectionRailStoreV2 } from './collection-rail-store-v2';

export class SearchRailStore extends CollectionRailStoreV2 {
  private errorHandler?: (error?: KuxErrorType) => void;

  constructor(
    categoryTree: KuxFilteredCategoriesDTO,
    parentCategoryTree: KuxFilteredCategoriesDTO,
    children?: [],
    handleAssetListErrors?: boolean,
    errorHandler?: (error?: KuxErrorType) => void,
  ) {
    super(categoryTree, parentCategoryTree, children, handleAssetListErrors);
    this.errorHandler = errorHandler;
  }

  @errorHandling({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: function (this: SearchRailStore, error: any) {
      this.errorHandlerCallback(error);
    },
  })
  protected async getData(
    pageIndex: number,
    items: (EntitiesType | CardPlaceholder)[],
  ): Promise<{ items: (EntitiesType | CardPlaceholder)[]; totalCount: number; newItems: EntitiesType[] }> {
    const { newItems, totalCount } = await getCollectionData({
      aggregatedKSQL: this.aggregatedKSQL,
      channelId: this.channels[0],
      dmsStore: this.dmsStore,
      groupBy: this.groupBy,
      // @ts-expect-error TODO Fix
      orderBy: this.orderBy,
      pageIndex,
      pageSize: this.pageSize,
      transactionStore: this.transactionStore,
    });
    this.innerItems.push(...newItems);
    return { items: this.items, totalCount, newItems };
  }

  protected errorHandlerCallback(error: KuxErrorType) {
    super.errorHandlerCallback();

    if (this.handleAssetListErrors && typeof this.errorHandler === 'function') {
      this.errorHandler(error);
    }
  }
}
